<template>
  <div style="margin-top: 30px; padding:11px;">
    <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
      Kıdem Tavanı Ekle
    </button>
    <br>
    <div class="table-responsive">
      <table class="table align-middle">
        <thead>
        <tr>
          <td><b> Kıdem Tavanı</b></td>
          <td><b> İşlemler </b></td>
        </tr>
        </thead>

        <tbody>
        <tr v-for="val in SeniorityBurdenData" v-bind:key="val.id">
          <td><b>{{ formatCurrency(val.seniorityCeilingPrice) }}</b></td> <!-- TL formatında gösterim -->
          <td>
            <button type="button" class="btn btn-danger"
                    data-bs-toggle="modal"
                    data-bs-target="#companyDeleteModal"
                    @click="setDeleteId(val.id)">Sil</button>
            &nbsp;
            <button type="button" class="btn btn-secondary"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    @click="editSeniorityCeiling(val)">Düzenle</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- Silme Onayı Modalı -->
    <div class="modal fade" id="companyDeleteModal" tabindex="-1" aria-labelledby="companyDeleteModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="companyDeleteModalLabel">Silme Onayı</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>Bu öğeyi silmek istediğinizden emin misiniz?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">İptal</button>
            <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="SeniorityBurdenDelete(deleteId)">Evet, Sil</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Kıdem Tavanı Ekle/Güncelle Modalı -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content" style="min-height: 500px; width: 750px; display: flex; flex-direction: column;">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ isEditing ? 'Kıdem Tazminatı Düzenle' : 'Kıdem Tazminatı Ekle' }}</h5>
            <button type="button" style="background-color: #2419d2;" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body" style="overflow-y: auto;">
            <div class="mb-3">
              <label for="seniorityCeilingPrice" class="form-label">Kıdem Tazminatı</label>
              <input type="number" class="form-control" id="seniorityCeilingPrice" v-model="itemsSeniorityBurden.seniorityCeilingPrice" placeholder="Kıdem Tazminatı">
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Vazgeç</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="isEditing ? updateSeniorityCeiling() : SeniorityCeilingSave()">
              {{ isEditing ? 'Güncelle' : 'Kaydet' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ts-nocheck

import apiClient from "@/axios";

export default {
  name: "SeniorityCeiling",
  data() {
    return {
      SeniorityBurdenData: [],
      deleteId: null,
      isEditing: false,  // Düzenleme kontrolü
      itemsSeniorityBurden: { seniorityCeilingPrice: null, id: null },  // Güncelleme için id ve fiyat
    };
  },
  created() {
    this.getSeniortyData();
  },
  methods: {
    // Kıdem Tavanı Kaydet
    SeniorityCeilingSave() {
      this.showNotification("Kıdem tavanı kaydediliyor...", "info");

      apiClient.post("/seniorityCeiling", this.itemsSeniorityBurden).then(res => {
        this.getSeniortyData();
        // Kaydettikten sonra formu temizle
        this.itemsSeniorityBurden = { seniorityCeilingPrice: null, id: null };
        this.showNotification("Kıdem tavanı başarıyla kaydedildi!", "success");
      }).catch(error => {
        console.error("Kaydetme işlemi sırasında hata oluştu:", error);
        this.showNotification("Kaydetme işlemi sırasında hata oluştu: " + error.message, "error");
      });
    },

    // Verileri al
    getSeniortyData() {
      apiClient.get("/seniorityCeiling").then(res => {
        this.SeniorityBurdenData = res.data;
      });
    },

    // Silme ID'sini ayarla
    setDeleteId(id) {
      this.deleteId = id;
    },

    // Silme işlemi
    SeniorityBurdenDelete(id) {
      apiClient.delete(`/seniorityCeiling/${id}`)
          .then(() => {
            this.getSeniortyData();
          })
          .catch(error => {
            console.error("Silme işlemi sırasında hata oluştu:", error);
          });
    },

    // Para birimini formatla
    formatCurrency(value) {
      if (value !== undefined && value !== null) {
        return new Intl.NumberFormat("tr-TR", {
          style: "currency",
          currency: "TRY",
        }).format(value); // TL formatında döndürme
      }
      return "₺0,00"; // Eğer değer boşsa, varsayılan bir değer döndür
    },

    // Düzenleme için modalı açma
    editSeniorityCeiling(data) {
      this.itemsSeniorityBurden = {
        seniorityCeilingPrice: data.seniorityCeilingPrice,
        id: data.id
      };
      this.isEditing = true;
    },

    // Kıdem Tavanı Güncelleme
    updateSeniorityCeiling() {
      // Show loading message
      this.showNotification("Kıdem tavanı güncelleniyor ve proje karlılıkları yeniden hesaplanıyor...", "info");

      apiClient.put(`/seniorityCeiling/${this.itemsSeniorityBurden.id}`, this.itemsSeniorityBurden).then(() => {
        this.getSeniortyData();
        this.isEditing = false;
        this.itemsSeniorityBurden = { seniorityCeilingPrice: null, id: null };
        this.showNotification("Kıdem tavanı başarıyla güncellendi ve tüm proje karlılıkları yeniden hesaplandı!", "success");
      }).catch(error => {
        console.error("Güncelleme işlemi sırasında hata oluştu:", error);
        this.showNotification("Güncelleme işlemi sırasında hata oluştu: " + error.message, "error");
      });
    },

    // Bildirim gösterme fonksiyonu
    showNotification(message, type = "info") {
      // Bootstrap alert kullanarak bildirim göster
      const alertDiv = document.createElement('div');
      alertDiv.className = `alert alert-${type === 'error' ? 'danger' : type} alert-dismissible fade show position-fixed`;
      alertDiv.style.cssText = 'top: 20px; right: 20px; z-index: 9999; min-width: 300px;';
      alertDiv.innerHTML = `
        ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      `;

      document.body.appendChild(alertDiv);

      // 5 saniye sonra otomatik kapat
      setTimeout(() => {
        if (alertDiv.parentNode) {
          alertDiv.parentNode.removeChild(alertDiv);
        }
      }, 5000);
    },
  },
}
</script>

<style scoped>

</style>
